import { Component } from '@angular/core';
import { DeliverableTemplateGridCellActions } from '../../models/deliverable-template-grid-cell-actions.model';

@Component({
  standalone: false,
  selector: 'app-deliverable-templates-table-actions-renderer',
  templateUrl: './deliverable-templates-table-actions-renderer.component.html'
})
export class DeliverableTemplatesTableActionsRendererComponent {
params?: DeliverableTemplateGridCellActions;

  // gets called once before the renderer is used
  agInit(params: DeliverableTemplateGridCellActions): void {
    this.params = params;
  }

  deleteClick() {
    this.params?.onDeleteClick(this.params.data.id!);
  }
}
